import {
  CREDIT_LINE_EXTERNAL_STATUS_TEXT,
  ITAU_CREDIT_LINE_EXTERNAL_STATUS_TEXT,
} from '../credit-line-external-colors';

export const RISK_PLATFORM_FEATURES = {
  RISK_ADD_RESTRICTIONS_BUTTON: 'risk.restrictions.addButton',
  MAFI_DOCUMENT_TYPE: 'company.documents.mafi',
  RISK_RESOLVE_RESTRICTIONS_BUTTON: 'risk.restrictions.resolveButton',
  RISK_FACTORING_TYPE_COLLECTION_TYPE_COLUMNS: 'risk.factoring.factoringTypeCollectionTypeColumns',
  CREDIT_LINE_EXTERNAL_STATUS_TEXT: 'risk.creditLine.externalStatus.text',
  RISK_TAIL_DEBTORS_EXPOSURE_WARNING: 'risk.accept.tailDebtorsExposureWarning',
  RISK_CONTRACT_SIGNING_ENDORSER: 'risk.restrictions.contractSigning.endorser',
};

export const RISK_PLATFORM_FEATURE_CONFIG = {
  BCH: {
    [RISK_PLATFORM_FEATURES.RISK_ADD_RESTRICTIONS_BUTTON]: true,
    [RISK_PLATFORM_FEATURES.MAFI_DOCUMENT_TYPE]: true,
    [RISK_PLATFORM_FEATURES.RISK_RESOLVE_RESTRICTIONS_BUTTON]: true,
    [RISK_PLATFORM_FEATURES.RISK_FACTORING_TYPE_COLLECTION_TYPE_COLUMNS]: [],
    [RISK_PLATFORM_FEATURES.CREDIT_LINE_EXTERNAL_STATUS_TEXT]:
      CREDIT_LINE_EXTERNAL_STATUS_TEXT,
    [RISK_PLATFORM_FEATURES.RISK_TAIL_DEBTORS_EXPOSURE_WARNING]: true,
    [RISK_PLATFORM_FEATURES.RISK_CONTRACT_SIGNING_ENDORSER]: false,
  },

  SANTANDER: {
    [RISK_PLATFORM_FEATURES.RISK_ADD_RESTRICTIONS_BUTTON]: true,
    [RISK_PLATFORM_FEATURES.MAFI_DOCUMENT_TYPE]: false,
    [RISK_PLATFORM_FEATURES.RISK_RESOLVE_RESTRICTIONS_BUTTON]: true,
    [RISK_PLATFORM_FEATURES.RISK_FACTORING_TYPE_COLLECTION_TYPE_COLUMNS]: [],
    [RISK_PLATFORM_FEATURES.CREDIT_LINE_EXTERNAL_STATUS_TEXT]:
      CREDIT_LINE_EXTERNAL_STATUS_TEXT,
    [RISK_PLATFORM_FEATURES.RISK_TAIL_DEBTORS_EXPOSURE_WARNING]: false,
    [RISK_PLATFORM_FEATURES.RISK_CONTRACT_SIGNING_ENDORSER]: true,
  },

  FINGO: {
    [RISK_PLATFORM_FEATURES.RISK_ADD_RESTRICTIONS_BUTTON]: true,
    [RISK_PLATFORM_FEATURES.MAFI_DOCUMENT_TYPE]: false,
    [RISK_PLATFORM_FEATURES.RISK_RESOLVE_RESTRICTIONS_BUTTON]: true,
    [RISK_PLATFORM_FEATURES.RISK_FACTORING_TYPE_COLLECTION_TYPE_COLUMNS]: [],
    [RISK_PLATFORM_FEATURES.CREDIT_LINE_EXTERNAL_STATUS_TEXT]:
      CREDIT_LINE_EXTERNAL_STATUS_TEXT,
    [RISK_PLATFORM_FEATURES.RISK_TAIL_DEBTORS_EXPOSURE_WARNING]: false,
    [RISK_PLATFORM_FEATURES.RISK_CONTRACT_SIGNING_ENDORSER]: true,
  },

  ITAU: {
    [RISK_PLATFORM_FEATURES.RISK_ADD_RESTRICTIONS_BUTTON]: true,
    [RISK_PLATFORM_FEATURES.MAFI_DOCUMENT_TYPE]: false,
    [RISK_PLATFORM_FEATURES.RISK_RESOLVE_RESTRICTIONS_BUTTON]: true,
    [RISK_PLATFORM_FEATURES.RISK_FACTORING_TYPE_COLLECTION_TYPE_COLUMNS]: ['factoringType', 'collectionType'],
    [RISK_PLATFORM_FEATURES.CREDIT_LINE_EXTERNAL_STATUS_TEXT]:
      ITAU_CREDIT_LINE_EXTERNAL_STATUS_TEXT,
    [RISK_PLATFORM_FEATURES.RISK_TAIL_DEBTORS_EXPOSURE_WARNING]: false,
    [RISK_PLATFORM_FEATURES.RISK_CONTRACT_SIGNING_ENDORSER]: true,
  },
};
